import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles'
import ReactTable from "react-table"
import matchSorter from 'match-sorter'
import "react-table/react-table.css";
import moment from 'moment'
import userdata from '../config/jwt_token'
let myMap = new Map()
myMap.set('vendor_update_request', 'Update Verified Vendor')
myMap.set('onboard_request', 'Onboarding')
myMap.set('delete_approved_vendor', 'Deletion')
myMap.set('update_rejected_request', 'Modified')
myMap.set('deactivate_approved_vendor', 'Deactivation')
myMap.set('activate_approved_vendor', 'Activation')

class VendorListTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: [],
      status: 'pending'
    }
  }
  componentDidMount(props) {
    if (this.props.data !== undefined) {
      this.setState({ data: this.props.data, status: this.props.status })
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.data !== undefined) {
      this.setState({ data: nextProps.data, status: nextProps.status })
    }
  }
  handleTable() {
    let columns = [
      {
        Header: "Vendor Code",
        id: "vendor_code",
        accessor: d => { return d.vendor_code !== null ? d.vendor_code : 'NA' },
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["vendor_code"] }),
        filterAll: true,
      },
      {
        Header: "Vendor Name",
        id: "name",
        accessor: d => d.name,
        style: { 'white-space': 'unset', 'word-wrap': 'break-word' },
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["name"] }),
        filterAll: true,
      },
      {
        Header: "City",
        id: "city_name",
        accessor: d => d.city_name,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["city_name"] }),
        filterAll: true,
      },
      {
        Header: "National Vendor",
        id: 'national',
        accessor: d => {return d.national? 'Yes' : 'No' },
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["national"] }),
        filterAll: true
      },
      {
        Header: "Contact Number",
        id: "contact_number",
        accessor: d => d.contact_number,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["contact_number"] }),
        filterAll: true,
      },
      {
        Header: "Pancard",
        id: "pancard_number",
        accessor: d => d.pancard_number,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["pancard_number"] }),
        filterAll: true
      },
      {
        Header: "GST Number",
        id: "gstn",
        accessor: d => d.gstn,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["gstn"] }),
        filterAll: true,
        width: 150
      },
      {
        Header: "Requester Name",
        id: "requester_name",
        style: { 'white-space': 'unset', 'word-wrap': 'break-word' },
        accessor: d => d.requester_name,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["requester_name"] }),
        filterAll: true,
      },
      {
        Header: "Onboarded Date",
        id: "updated_at",
        accessor: d => { return moment(d.updated_at, 'YYYY/MM/DD').format("DD MMM YYYY") },
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["updated_at"] }),
        filterAll: true
      },
      {
        Header: ((userdata.role === 'Central Finance') && (this.state.status !== 'approved') ? "Approve/Reject" : "View Details"),
        id: d => d.preview,
        accessor: d => d.preview,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["preview"] }),
        filterAll: true,
        minWidth: 130
      },
    ]
    if (this.state.status !== 'approved') {
      columns.splice(6, 0,
        {
          Header: "Request Type",
          id: "transaction_type",
          style: { 'white-space': 'unset', 'word-wrap': 'break-word' },
          accessor: d => { return myMap.get(d.transaction_type) },
          // getProps: (state, rowInfo) => {
          //   // console.log(rowInfo.row.transaction_type)
          //   if(rowInfo && rowInfo.row) {
          //   return {
          //     style: {
          //       backgroundColor:
          //         (rowInfo.row.transaction_type === "Onboarding" ? "lightgreen" : 
          //         rowInfo.row.transaction_type === "Modified" ? "lightyellow" :"#FF6347")
          //     }

          //   };
          // }
          // else{
          //   return {}
          // }
          // },
          filterMethod: (filter, rows) =>
            matchSorter(rows, filter.value, { keys: ["transaction_type"] }),
          filterAll: true,
        })
      columns.splice(7, 0, {
        Header: "Status",
        id: d => d.status,
        accessor: d => d.status,
        filterMethod: (filter, rows) =>
          matchSorter(rows, filter.value, { keys: ["status"] }),
        filterAll: true
      })
    }
    return (
      <div>
        <ReactTable
          style={{ textAlign: "center", margin: '20px' }}
          data={this.state.data}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row && this.state.status !== 'approved') {
              return {
                style: {
                  color:
                    (
                      rowInfo.row.transaction_type === "Onboarding" ? "green" :
                        rowInfo.row.transaction_type === "Modified" ? "blue" : "#FF6347")
                }
              };
            } else if (rowInfo && rowInfo.row && this.state.status === 'approved') {
              return {
                style: {
                  color: (rowInfo.original.vendor_deactivate == 1 && "#FF6347")
                }
              };
            }
            else {
              return {}
            }
          }}
          filterable
          defaultFilterMethod={(filter, row) =>
            String(row[filter.id]) === filter.value}
          columns={[
            {
              columns: columns
            }
          ]}
          defaultPageSize={10}
          className="-striped -highlight"
        />
      </div>
    )
  }
  render() {
    return (
      < MuiThemeProvider>
        {this.handleTable(this.state.data)}
      </MuiThemeProvider>
    )
  }
}
export default VendorListTable


// WEBPACK FOOTER //
// ./src/components/VendorListtable.js